import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { profileApi } from '@entities/profile';
import { showToast } from '@features/ToastManager';

import { PROFILE_TOAST_SCOPE } from './toast';

import type { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const useDeleteProfile = () => {
    const { t } = useTranslation();
    const mutation = useMutation({
        mutationFn: profileApi.deleteProfile,
        onSuccess: () => window.location.reload(),
        onError: (error) => {
            const responseError = isAxiosError<IDataResponseError>(error)
                ? error.response?.data
                : undefined;
            showToast(
                responseError?.message ?? t('profile.page.settings.deleteAccount.error'),
                { scope: PROFILE_TOAST_SCOPE, type: 'error' }
            );
        },
    });

    return { deleteProfile: mutation.mutate, isPending: mutation.isPending };
};
